import React from 'react';
import { Countdown } from './Countdown';
import { useCountdown } from '../hooks/useCountdown';
import { PRICE, REGULAR_PRICE } from '../data/offer';

/** Ventana de lanzamiento con fecha fija (data/offer.ts). Se oculta al vencer. */
export function Urgency() {
  const time = useCountdown();
  if (time.expired) return null;
  return <section className="w-full bg-sage-deep" data-id="element-344" data-mp="21wx1m73wd38j">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:py-16" data-id="element-345" data-mp="1o7d5hk4tn487">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-ochre" data-id="element-346" data-mp="1o50ekhh35jj0">
          Launch price
        </p>
        <h2 className="mt-3 font-display text-2xl text-cream sm:text-4xl" data-id="element-347" data-mp="1e8xfjkhj610a">
          ${PRICE} until the launch window closes:
        </h2>
        <div className="mt-6" data-id="element-348" data-mp="1j91uv76pcpox">
          <Countdown time={time} tone="dark" data-id="element-349" data-mp="1j8a2e58ej82v" />
        </div>
        <p className="mt-5 text-sm text-cream/70" data-id="element-350" data-mp="159aa8nlokb1y">
          After that it goes back to the regular price of{' '}
          <span className="font-bold text-terra-soft" data-id="element-351" data-mp="198j5jwwdcgzm">${REGULAR_PRICE}</span>.
        </p>
      </div>
    </section>;
}